import React, { useState, useEffect } from "react";
import "./LimitedEdition.css";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, addToCartAsync } from "../../../Features/Cart/cartSlice";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import { Link, useNavigate } from "react-router-dom";
import { FiHeart } from "react-icons/fi";
import { FaStar } from "react-icons/fa";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { FaCartPlus } from "react-icons/fa";
import toast from "react-hot-toast";
import df from '../../../Assets/Brands/default.png'

const LimitedEdition = () => {
  const dispatch = useDispatch();
  const [medicines, setMedicines] = useState([]);
  const [wishList, setWishList] = useState({});
  const userId = useSelector((state) => state.user.user?._id);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("https://api.swasthmitra.com/api/medicine")
      .then((response) => response.json())
      .then((data) => setMedicines(data))
      .catch((error) => console.error("Error fetching medicines:", error));
  }, []);

  const handleWishlistClick = (productID) => {
    setWishList((prevWishlist) => ({
      ...prevWishlist,
      [productID]: !prevWishlist[productID],
    }));
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const cartItems = useSelector((state) => state.cart.items);

  const handleAddToCart = async (product) => {
    if (!userId) {
      toast.error("Please login to add items to cart");
      navigate('/login')
      return;
    }
    const productInCart = cartItems.find(
      (item) => item.productID === product._id
    );

    if (productInCart && productInCart.quantity >= 20) {
      toast.error("Product limit reached", {
        duration: 2000,
        style: {
          backgroundColor: "#ff4b4b",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#ff4b4b",
        },
      });
    } else {
      try {
        const cartItem = {
          productID: product._id,
          productName: product.name,
          dealRate: parseFloat(product.salePrice),
          productImage: product.imageUrl || "",
          quantity: 1,
          batchNumber: product.batchNumber,
          brand: product.brand,
          packOf: product.packOf,
          gst: product.gst,
          mrp: product.mrp,
          expiryDate: product.expiryDate,
        };
        await dispatch(
          addToCartAsync({
            userId,
            productID: product._id,
            quantity: 1,
          })
        );
        dispatch(addToCart(cartItem));
        toast.success(`${product.name} added to cart!`, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } catch (error) {
        toast.error("Failed to add item to cart");
      }
    }
  };

  return (
    <div className="limitedProductSection">
      <div className="sectionHeader">
        <h2>
          BEST-SELLING <span>PRODUCTS</span>
        </h2>
        <p className="sectionSubtitle">Premium quality at affordable prices</p>
      </div>
      
      <div className="limitedProductSlider">
        <div className="swiper-button image-swiper-button-next">
          <IoIosArrowForward />
        </div>
        <div className="swiper-button image-swiper-button-prev">
          <IoIosArrowBack />
        </div>
        
        <Swiper
          slidesPerView={4}
          slidesPerGroup={4}
          spaceBetween={30}
          loop={true}
          navigation={{
            nextEl: ".image-swiper-button-next",
            prevEl: ".image-swiper-button-prev",
          }}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          modules={[Navigation, Autoplay]}
          breakpoints={{
            320: {
              slidesPerView: 2,
              slidesPerGroup: 1,
              spaceBetween: 14,
            },
            768: {
              slidesPerView: 3,
              slidesPerGroup: 1,
              spaceBetween: 24,
            },
            1024: {
              slidesPerView: 4,
              slidesPerGroup: 1,
              spaceBetween: 30,
            },
          }}
        >
          {medicines.map((medicine) => (
            <SwiperSlide key={medicine._id}>
              <div className="lpContainer">
                <div className="lpImageContainer">
                  {medicine.dealRate < medicine.mrp && (
                    <div className="productBadge">
                      {Math.round(
                        ((medicine.mrp - medicine.dealRate) / medicine.mrp) *
                          100
                      )}% OFF
                    </div>
                  )}
                  <Link to={`/product/${medicine._id}`} onClick={scrollToTop}>
                    <img
                      src={
                        medicine.imageUrl ||
                        medicine.imageUrls?.[0] ||
                        df
                      }
                      alt={medicine.name}
                      className="lpImage"
                      onError={(e) => {
                        e.target.src = "/default-medicine.png";
                      }}
                    />
                  </Link>
                  <button
                    className={`add-to-cart-button1 ${
                      cartItems.some((item) => item.productID === medicine._id)
                        ? "disabled"
                        : ""
                    }`}
                    onClick={() => {
                      if (
                        !cartItems.some(
                          (item) => item.productID === medicine._id
                        )
                      ) {
                        handleAddToCart(medicine);
                      }
                    }}
                  >
                    {cartItems.some((item) => item.productID === medicine._id)
                      ? "In Cart"
                      : "Add to Cart"}
                  </button>
                </div>

                <div className="limitedProductInfo">
                  <div className="lpCategoryWishlist">
                    <div className="sty"><span className="productCategory">{medicine.category}</span></div>
                    <FiHeart
                      className={`wishlist-icon ${
                        wishList[medicine._id] ? "active" : ""
                      }`}
                      onClick={() => handleWishlistClick(medicine._id)}
                    />
                  </div>
                  <div className="productNameInfo">
                    <Link to={`/product/${medicine._id}`} onClick={scrollToTop}>
                      <h5>{medicine.name}</h5>
                    </Link>
                    <div className="priceRatingContainer">
                      <span className="productPrice">{medicine.dealRate} ₹</span>
                      <span className="originalPrice">{medicine.mrp} ₹</span>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default LimitedEdition;